import { render, staticRenderFns } from "./ProductsCheckout.vue?vue&type=template&id=36375644&"
import script from "./ProductsCheckout.vue?vue&type=script&lang=js&"
export * from "./ProductsCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports